var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalaryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 195,
    viewBox: "0 0 246 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.521 105.639C178.802 104.651 177.626 104.226 176.451 104.53C175.276 104.835 174.286 105.82 173.867 107.103L161.974 143.465C161.549 144.765 161.777 146.162 162.567 147.102C163.357 148.041 164.581 148.37 165.754 147.96L196.313 137.255C197.396 136.875 198.28 135.918 198.66 134.713C199.039 133.508 198.861 132.221 198.188 131.296L179.521 105.639Z",
    fill: "#BFBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.87 68.3358C154.432 65.5763 145.008 71.2422 141.82 80.9907L121.037 144.536C117.849 154.284 122.104 164.424 130.541 167.184L197.761 189.168C206.199 191.927 215.623 186.262 218.811 176.513L239.594 112.968C242.782 103.219 238.527 93.0797 230.09 90.3202L162.87 68.3358ZM147.931 82.9893C149.843 77.1401 155.498 73.7407 160.561 75.3964L227.781 97.3808C232.843 99.0364 235.396 105.12 233.483 110.969L212.701 174.514C210.788 180.363 205.133 183.763 200.07 182.107L132.851 160.123C127.788 158.467 125.235 152.383 127.148 146.534L147.931 82.9893Z",
    fill: "#BFBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9097 4.86784L10.3727 38.8703C4.64967 41.553 2.18503 48.3672 4.86775 54.0902L38.8702 126.627C41.5529 132.35 48.3671 134.815 54.0901 132.132L126.627 98.1298C132.35 95.447 134.815 88.6329 132.132 82.9098L98.1297 10.3728C95.4469 4.64977 88.6328 2.18512 82.9097 4.86784Z",
    stroke: "#BFBBBB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5083 66.6383C49.8005 64.6262 51.649 59.5156 49.637 55.2233C47.6249 50.9311 42.5143 49.0826 38.222 51.0946C33.9298 53.1067 32.0813 58.2173 34.0933 62.5096C36.1054 66.8018 41.216 68.6503 45.5083 66.6383Z",
    stroke: "#BFBBBB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.417 62.1849L84.3673 48.4226L54.0901 132.132",
    stroke: "#BFBBBB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaryicon);
export default __webpack_public_path__ + "static/media/galary icon.13e0cb4827b04c31b21d983e8ac628cf.svg";
export { ForwardRef as ReactComponent };